<template>
  <div>
    <el-button type="primary" size="small" @click="handleDialogShow()" v-if="!readOnly">新增</el-button>
    <el-table :data="tableData" border :height="250" v-loading="tableData === null">
      <el-table-column label="出货时间" prop="shipmentTime"></el-table-column>
      <el-table-column label="出货数量" prop="shipmentCount"></el-table-column>
      <el-table-column label="更新人" prop="updatedBy">
        <template slot-scope="scope">
          <span>{{scope.row.updatedBy || scope.row.createdBy}}</span>
        </template>
      </el-table-column>
      <el-table-column label="修改时间" prop="updatedDate"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
           type="text"
          @click="handleDialogShow(scope.row)"
           v-if="new Date(scope.row.shipmentTime).getTime() > new Date().getTime() && !readOnly">
           编辑
           </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right; margin-top: 10px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationOpt.pageNum"
        :page-sizes="paginationOpt.pageSizes"
        :page-size="paginationOpt.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="paginationOpt.total">
      </el-pagination>
    </div>
    <v-dialog v-model="dialogVisible" :config="{ width: '50%', title: title, confirmCallback: true }" @dialogConfirm="dialogConfirm">
      <div slot="content">
        <add :data="rowData" :packCode="formData.packCode" v-if="dialogVisible && title === '新增'" ref="child"></add>
        <edit :data="rowData" :packCode="formData.packCode" v-if="dialogVisible && title === '编辑'" ref="child"></edit>
      </div>
    </v-dialog>
  </div>
</template>

<script>
  import vDialog from '@/views/operationAnalysis/common/dialog'
  import add from './components/add/add'
  import edit from './components/edit/edit'

  export default {
  components: { vDialog, add, edit },
  props: ['data'],
  data() {
    return {
      tableData: null,
      paginationOpt: {
        pageSizes: [30, 100, 500, 1000],
        pageNum: 1,
        pageSize: 30,
        total: 0
      },
      dialogVisible: false,
      rowData: null,
      title: '新增',
      readOnly: false
    }
  },
  watch: {
    '$route' : {
      handler (to, from) {
        let readOnly = this.$route.query.reply;
        this.readOnly = readOnly === 'readOnly' ? true : false
      },
      immediate: true
    }
  },
  computed: {
    formData() {
      return this.data
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let data = {
        filterData: {
          packCode: this.formData.packCode,
          packName: this.formData.packName
        },
        pageNum: this.paginationOpt.pageNum,
        pageSize: this.paginationOpt.pageSize
      }
      this.$q.orderDate.deliverySelectReply({data: data})
      .then(res=>{
        if(res.success && res.data && res.data.records.length) {
          this.tableData = res.data.records
          let paginationOpt = {
            total: res.data.total,
            pageNum: res.data.pageNum
          }
          this.paginationOpt = { ...this.paginationOpt, ...paginationOpt }
        }else{
          this.tableData = []
        }
      })
    },
    handleDialogShow(row) {
      this.title = '新增'
      if(row) {
        this.rowData = row;
        this.title = '编辑'
      }
      this.dialogVisible = true;
    },
    handleSizeChange(val) {
      this.tableData = null;
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    handleCurrentChange(val) {
      this.tableData = null;
      this.paginationOpt.pageNum = val;
      this.init();
    },
    async dialogConfirm() {
      let res;
      if(this.title === '新增') {
        let dataList = this.$refs['child'].formList;
        res = await this.add(dataList,0);
      }else{
        let data = this.$refs['child'].form;
        res = await this.edit(data);
      }

      if(!res) return;

      this.dialogVisible = false;
      this.init();
      console.log('complete');
    },
    checkValidate (index) {
      return new Promise((resolve,reject)=>{
        this.$refs['child'].$refs[`ruleForm${index}`][0].validate((valid) => {
          if (valid) {
            resolve(valid)
          } else {
            resolve(false)
          }
        });
      })
    },
    async add(data,index) {
      let status = await this.checkValidate(index);
      if(!status) return Promise.resolve(false);

      return await this.$q.orderDate.deliveryInsertReply({data:data[index]})
      .finally(_=>{
        console.log(index);
        if(data.length - 1 === index) return false;
        index++;
        return this.add(data,index)
      })
    },
    checkValidateEdit () {
      return new Promise((resolve,reject)=>{
        this.$refs['child'].$refs[`ruleForm`].validate((valid) => {
          if (valid) {
            resolve(valid)
          } else {
            resolve(false)
          }
        });
      })
    },
    async edit(data) {
      let status = await this.checkValidateEdit();
      if(!status) return Promise.resolve(false);
      return this.$q.orderDate.deliveryUpdateReply({data:data})
    }
  }
}
</script>

<style lang="stylus" scoped>

</style>
